import React from 'react';
import InfoField from './InfoField';

const PersonalReportSection = ({ personalData }) => {
  if (!personalData) {
    return (
      <div className="report-section">
        <h2 className="section-title">Personal Report</h2>
        <p>No personal details available.</p>
      </div>
    );
  }

  return (
    <div className="report-section">
      <h2 className="section-title">Personal Report</h2>
      <div className="grid-container">
        <InfoField label="Candidate First Name" value={personalData.firstName || 'N/A'} />
        <InfoField label="Candidate Last Name" value={personalData.lastName || 'N/A'} />
        <InfoField label="Candidate Date Of Birth" value={personalData.dob || 'N/A'} />
        <InfoField label="Father's Name" value={personalData.fatherName || 'N/A'} />
        <InfoField label="Mobile Number" value={personalData.mobileNumber || 'N/A'} />
        <InfoField label="Candidate Email" value={personalData.email || 'N/A'} />
        <InfoField label="Candidate ID" value={personalData.candidateId || 'N/A'} />
        <InfoField label="Employee ID" value={personalData.employeeId || 'N/A'} />
        <InfoField label="Verification Status" value={personalData.verificationStatus ? 'Verified' : 'Not Verified'} />
      </div>
    </div>
  );
};

export default PersonalReportSection;